import React, { useMemo } from 'react';
import { getHost } from '../../utils/url';

function ExternalLinkIcon({ className = 'w-4 h-4' }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M11 3a1 1 0 100 2h2.586L8.293 10.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 100-2H5z" />
    </svg>
  );
}

export default function ExternalDataAppsBar({ apps }) {
  const rows = useMemo(() => (apps || []).map(app => ({ ...app, host: getHost(app.url) })), [apps]);

  if (rows.length === 0) return null;

  return (
    <div
      className={[
        'rounded-xl border border-gray-200/80 dark:border-gray-800/80',
        'bg-white/70 dark:bg-gray-900/60 backdrop-blur',
        'shadow-sm',
        'px-2 py-2',
      ].join(' ')}
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-2 px-2 py-1">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200" aria-hidden="true">
            <ExternalLinkIcon />
          </span>
          <span className="text-sm font-semibold tracking-wide text-gray-900 dark:text-white">
            Applications Data
          </span>
        </div>

        <div className="flex flex-wrap gap-2 sm:flex-1">
          {rows.map((app) => (
            <a
              key={app.id}
              href={app.url}
              target="_blank"
              rel="noopener noreferrer"
              className={[
                'group inline-flex items-center gap-2',
                'rounded-lg border border-gray-200/80 dark:border-gray-800/80',
                'bg-white/80 dark:bg-gray-900/60',
                'px-3 py-2',
                'hover:bg-gray-50 dark:hover:bg-gray-800/40',
                'transition-colors',
                'min-w-[140px]',
              ].join(' ')}
              title={app.host}
            >
              <span className="text-sm font-medium text-gray-900 dark:text-white">
                {app.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

